module.exports = __webpack_public_path__ + "media/newstyle/images/icon-upload-white-0e931d2201a30592abe9f0f9eb92bc75.svg";